/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Cost_CurrencyInputs */

const en_field_cost_currency = /** @type {(inputs: Field_Cost_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost currency`)
};

/**
* | output |
* | --- |
* | "Cost currency" |
*
* @param {Field_Cost_CurrencyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_cost_currency = /** @type {((inputs?: Field_Cost_CurrencyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Cost_CurrencyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_cost_currency(inputs)
});